import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { endpoint } from './constants';
import { ApiResponse, FavouriteDefinition } from 'app/types-shared';

export const api = {

  exportCases: async (definition: FavouriteDefinition): Promise<any> => {
    const response = await new RemoteData(endpoint.exportCases).resource<ApiResponse<any>>().create(definition, false);
    return await response;
  },

  loadFavouriteDefinition: async (id: string | number): Promise<FavouriteDefinition> => {

    const response = await new RemoteData(endpoint.favouriteDefinition).resource<ApiResponse<FavouriteDefinition>>()
      .withId(id)
      .single();

    return await response.data;
  }
};
